<template>
  <div class="secretWrap">
    <div class="wrap secretFree-wrap clearfix">
      <headerUserCenter v-if="isUnion" />
      <crumb v-if="!isUnion" />
      <div class="fl">
        <user-left v-if="!isUnion"></user-left>
        <userLeftForBFD v-else></userLeftForBFD>
      </div>
      <div class="fl ml-8">
        <div class="mainWrap">
          <div class="tabs">
            <div class="tabList" @click="goSetting">{{TLang('基础信息','list')}}</div>
            <div class="tabList active">{{TLang('支付设置','list')}}</div>
          </div>
          <div class="clearfix secretFreeSet">
            <div class="fl label">
              {{TLang('免密抵扣','list')}}
            </div>
            <div class="fl switch">
              <el-switch
                v-model="value"
                :width="56"
                active-color="#3D96E2"
                inactive-color="#f0f0f0"
                @change="currentValue"
              >
              </el-switch>
            </div>
            <div class="fl tips">
              {{TLang('抵扣金额','list')}}≤{{ noPasswordMoney * union_scale }}{{TLang('时无需支付密码下单更便捷','list')}}。
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="bindPhoneTipVisible"
      width="420px"
      top="40vh"
      center
      :before-close="handleClosebindPhoneTip"
      custom-class="bindPhoneTipWrap"
    >
      <div class="bindPhoneTipDialog">
        <span class="title">{{TLang('您还未绑定手机号','list')}}</span>
        <span class="title">{{TLang('请先绑定','list')}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="cacel-btn" @click="handleClosebindPhoneTip">{{TLang('再想想','address')}}</el-button>
          <el-button type="primary" class="yes-btn" @click="bindPhoneTipNext">{{TLang('去绑定','address')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 未设置支付密码提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="noPayPwdModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="noPayPwdModalVisible = false"
    >
      <div class="content">
        <div class="state">
          <div>{{TLang('NoPwd1','orderConfirm')}}，</div>
          <div>{{TLang('NoPwd2','orderConfirm')}}</div>
        </div>
        <div class="btns">
          <div
            class="cacel-btn"
            @click="noPayPwdModalVisible = false"
          >
            {{TLang('再想想','address')}}
          </div>
          <div
            class="yes-btn"
            @click="openSetPwdModal"
          >
            {{TLang('去设置','list')}}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 关闭免密提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="closeFreeSetVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="closeFreeSetVisible = false"
    >
      <div class="content">
        <div class="state">
          <div>{{TLang('关闭免密抵扣后会增加下单时间','list')}}</div>
          <div>{{TLang('确认关闭','list')}}</div>
        </div>
        <div class="btns">
          <div
            class="cacel-btn"
            @click="openCloseFreeModal"
          >
            {{TLang('确认关闭','list')}}
          </div>
          <div
            class="yes-btn"
            @click="closeFreeSetVisible = false"
          >
            {{TLang('再想想','address')}}
          </div>
        </div>
      </div>
    </Dialog>
    

    <!-- 退出设置免密二次确认提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="quitModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="false"
      top="40vh"
      @close="quitModalVisible=false"
    >
      <div class="content">
        <div class="state">
          <div>{{TLang('是否退出免密设置','list')}}</div>
        </div>
        <div class="btns">
          <div
            class="cacel-btn"
            @click="quitPwdSet"
          >
            {{TLang('退出','orderConfirm')}}
          </div>
          <div
            class="yes-btn"
            @click="goOnSet"
          >
            {{TLang('继续设置','orderConfirm')}}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 绑定手机/获取短信验证码弹窗 -->
    <Dialog
      :title="modalTitle"
      custom-class="my-custom-modal bind-mobile-modal"
      :visible="bindTelModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      :before-close="(done) => closeClick(done, 'bindPhone')"
    >
      <div class="content">
        <div class="input-wrap mb18">
          <div class="name">
            {{TLang('手机号','address')}}
          </div>
          <input
            v-if="!mobile"
            v-model="phone"
            class="box"
            type="tel"
            maxlength="11"
            :placeholder="TLang('请输入11位手机号','address')"
            autocomplete="new-password"
          />
          <div
            v-else
            class="mobile"
          >
            {{ mobile | mobileFormat }}
          </div>
        </div>
        <div class="input-wrap">
          <div class="name">
            {{ TLang('验证码','address') }}
          </div>
          <div class="box sms">
            <input
              ref="smsCode"
              v-model="smsCode"
              type="tel"
              maxlength="6"
              class="sms-code"
              :placeholder="TLang('请输入验证码','address')"
              autocomplete="new-password"
              autofocus="autofocus"
            />
            <div
              v-if="time == 60"
              class="get-code"
              @click="sendSms"
            >
              {{TLang('获取验证码','address')}}
            </div>
            <div
              v-else
              class="reget-code"
            >
              {{ TLang('重新发送','address') }}({{ time }}S)
            </div>
          </div>
        </div>
        <div
          class="next"
          :class="{ active: smsCode != '' }"
          @click="valiSms"
        >
          {{ TLang('下一步','address') }}
        </div>
      </div>
    </Dialog>
    <!-- 短信验证码弹窗 -->
    <Dialog
      :title="TLang('输入短信验证码','address')"
      custom-class="my-custom-modal input-sms-modal"
      :visible="smsModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="smsModalVisibl = false"
    >
      <div>{{ TLang('待完善','address') }}</div>
    </Dialog>
    <Dialog
      :title="TLang('设置4位支付密码','list')"
      :visible="setPwdModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      custom-class="my-custom-modal"
      :before-close="(done)=>closeClick(done,'setPwd')"
    >
      <div class="content">
        <div class="item mb24">
          <div class="name pl28">
            {{TLang('新的支付密码','address')}}
          </div>
          <input
            v-model="paymentPwd"
            type="password"
            maxlength="4"
            :placeholder="TLang('输入4位数字密码','address')"
          />
        </div>
        <div class="item mb8">
          <div class="name">
            {{ TLang('确认新的支付密码','address') }}
          </div>
          <input
            v-model="reInputPaymentPwd"
            maxlength="4"
            type="password"
            :placeholder="TLang('再次输入4位数字密码','address')"
          />
        </div>
        <div
          v-if="setPayPwdTips"
          class="tips"
        >
          <!-- <img src="" alt="icon"> -->
          <span>{{ setPayPwdTips }}</span>
        </div>
        <div
          v-else
          class="empty-tips"
        ></div>
        <div
          class="confirm-btn active"
          @click="confirmSetPwd"
        >
          {{TLang('确认设置','address')}}
        </div>
      </div>
    </Dialog>
    <!-- 设置密码成功提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="setPwdSuccessModal"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="setPwdSuccessModal = false"
    >
      <div class="content">
        <div class="state">
          <div>{{TLang('密码设置成功','orderConfirm')}}</div>
          <div>{{TLang('将为您开通免密设置','list')}}</div>
        </div>
        <div class="single-btn-wrap">
          <div
            class="yes-btn"
            @click="afterSetSuccess"
          >
            {{TLang('知道了','orderConfirm')}}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 开通失败提示弹窗 -->
    <Dialog
      title=""
      custom-class="my-tip-modal"
      :visible="deductionFaliedModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="deductionFaliedModalVisible = false"
    >
      <div class="content">
        <div class="state">
          <div>{{ TLang('本次开通失败','list') }}</div>
          <div>{{ TLang('请重新设置','list') }}</div>
        </div>
        <div class="single-btn-wrap">
          <div
            class="yes-btn"
            @click="reloadPage"
          >
            {{ TLang('重新设置','list') }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 支付弹窗 -->
    <Dialog
      :title="TLang('输入支付密码','orderConfirm')"
      custom-class="my-custom-modal input-pwd-modal"
      :visible="inputPwdModalVisible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
      top="40vh"
      @close="inputPwdModalVisible = false"
    >
      <div class="content">
        <div class="pwd-wrap">
          <input
            ref="node1"
            v-model="pw1"
            type="password"
            maxlength="1"
            @keyup="focusNext(pw1, 'node2','')"
          />
          <input
            ref="node2"
            v-model="pw2"
            type="password"
            maxlength="1"
            @keyup="focusNext(pw2, 'node3','node1')"
          />
          <input
            ref="node3"
            v-model="pw3"
            type="password"
            maxlength="1"
            @keyup="focusNext(pw3, 'node4','node2')"
          />
          <input
            ref="node4"
            v-model="pw4"
            type="password"
            maxlength="1"
            @keyup="focusNext(pw4, '','node3')"
          />
        </div>
        <div class="second-row">
          <div
            v-if="inputPwdError"
            class="error-info"
          >
            {{ inputPwdError }}
          </div>
          <div
            v-if="dongjieShow"
            class="error-info"
          >
            {{ `${TLang('密码已被冻结','orderConfirm')}${countDownTimer}${TLang('后再试','orderConfirm')}` }}
          </div>
          <div
            v-else
            class="error-info"
          ></div>
          <div
            class="forgrt-pwsd"
            @click="forgrtPwd"
          >
            {{ TLang('忘记密码','orderConfirm') }}
          </div>
        </div>
        <div class="btn-wrap">
          <div
            :class="{'confirm-pay-btn':true,'active':!!pw1&!!pw2&!!pw3&!!pw4}"
            @click="validatePayPwd"
          >
            {{ TLang('确定','orderConfirm') }}
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui';
import API_ENV from '@utils/API_ENV';
import { sha } from '@/utils/SHA';
import { 
  getUserInfoHandle,
  getSmsHandle,
  valiSmsHandle,
  updateMobileHandle,
  setPaymentPwdHandle,
  validatePaymentPwdHandle,
  openFreePay,
} from '@fetch/order';
let appid = '100037';
const secretKey = 'TQaXTvES';
import { unionFlag, getQueryString } from '@utils';
import { formatDateTime, getMessageToCode} from '@/utils/index';
import Toast from '@components/simpleToast';
import userLeft from './components/user';
import userLeftForBFD from './components/user/bfd';
import headerUserCenter from './components/bfdHeader';
import crumb from './components/crumb';

const cityId = getQueryString('city');
const union = getQueryString('union') || unionFlag();
let _interval;
export default {
  name: 'SecretFree',
  components: {
    userLeft,
    userLeftForBFD,
    headerUserCenter,
    crumb,
    Dialog,
  },
  data() {
    return {
      tab: 0,
      currPage: 1,
      pagesize: 10,
      totalCount: 0,
      searchOrderNo: null, // 搜索中的订单编号
      isUnion: false, // 是否工会
      bfdHistoryLink: window.location.protocol + '//' + window.location.host.replace(/^www./,'') + `/user/order/goods?city=${cityId}&union=${union}`,
      historyLink: `/user/center/order/goods?city=${cityId}`,

      activeName: 'secret',
      value: false,
      noPasswordMoney: 0, // 免密额度
      mobile: '', //用户手机号
      hasPayPasswordSet: false, //用户是否已设置支付密码
      modalTitle: TLang('绑定您的手机号','orderConfirm'),

      dongjieShow: false, // 冻结
      quitModalVisible: false, // 退出密码设置二次弹框

      testVisible: true,
      unChooseRightsModalVisible: false, //未选择福利卡/账户积分余额提示弹窗
      bindPhoneTipVisible: false, // 绑定手机号提示
      bindTelModalVisible: false, //绑定手机号
      smsModalVisible: false, //短信验证码弹窗
      setPwdModalVisible: false, //设置支付密码弹窗
      setPwdSuccessModal: false,
      setPayPwdTips: '', //设置支付密码的错误提示信息
      inputPwdModalVisible: false, //支付弹窗
      inputPwdError: '', //密码错误信息
      pw1: '', //支付密码第1位
      pw2: '', //支付密码第2位
      pw3: '', //支付密码第3位
      pw4: '', //支付密码第4位
      paymentPwd: '', //第一次录入的支付密码
      reInputPaymentPwd: '', //再次输入的支付密码
      deductionFaliedModalVisible: false, //抵扣失败提示弹窗
      noPayPwdModalVisible: false, //未设置支付密码提示弹窗
      time: 60, //倒计时秒数
      smsCode: '', //短信验证码
      phone:'',
      countDownTimer: '',
      clearTimer: null,
      currentStep:'',
      noSecretSet: false, // 免密抵扣设置 false 未勾选 true 已勾选
      originMianmiState:'',
      closeFreeSetVisible: false, // 关闭免密弹框
      clickSendSms: false, // 用户是否点击发送验证码
      unionFlag: unionFlag() || sessionStorage.getItem('dffl_union'),
    };
  },

  created() {
    if (unionFlag()) {
      this.isUnion = !this.isUnion;
      console.log(this.apis);
    }
    this.getUserInfo();
  },

  methods: {
    /**
     * 切换tab
     */
    handleClick(tab) {
      if (tab.index == 0) {
        this.goSetting();
      }
    },
    leaveTab(activeName, oldActiveName) {
      if (oldActiveName == 'secret') {
        this.goSetting();
      }
    },
    goSetting() {
      window.df_sdk_common.location.href = window.location.origin + '/user/center/userInfo?city=' + cityId;
    },
    currentValue(value) {
      console.log(value, '当前状态');
      if (value) {
        this.value = !value;
        // 开启
        if (!this.mobile){
          // 未绑定手机号，开启绑定手机号弹窗
          this.bindPhoneTipVisible = true;
        } else if (this.hasPayPasswordSet) {
          // 绑定了手机号，且设置了支付密码，直接弹支付密码框
          this.inputPwdModalVisible = true;
        } else {
          // 无支付密码
          this.noPayPwdModalVisible = true;
        }
      } else {
        // 关闭
        console.log('关闭啦');
        this.value = !value;
        this.closeFreeSetVisible = true;
      }
    },
    // 关闭绑定手机号提示弹框
    handleClosebindPhoneTip() {
      this.bindPhoneTipVisible = false;
    },
    // 绑定手机号提示弹框下一步
    bindPhoneTipNext() {
      this.bindPhoneTipVisible = false;
      this.currentStep==='bindPhone';
      this.bindTelModalVisible = true;
      this.clickSendSms = false;
      this.smsCode = '';
      this.modalTitle = this.TLang('绑定您的手机号','orderConfirm');
    },
    /**
     * 用户信息查询
     */
    getUserInfo() {
      let params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          smsType: 2,
          sourceSys: 1,
          sourceWay: 2,
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      getUserInfoHandle(params).then((res) => {
        if (res && res.data) {
          this.mobile = res.data.mobile;
          this.hasPayPasswordSet = res.data.hasPayPasswordSet;
          if (res.data.mobile) {
            this.modalTitle = this.TLang('输入短信验证码','address');
          }
          this.noPasswordMoney = parseFloat(res.data.noPasswordMoney / 100);
          if(res.data.tagType.includes(30)) {
            this.value = true;
          }
        }
      });
    },
    /**
     * 立即设置支付密码
     */
    openSetPwdModal() {
      this.noPayPwdModalVisible = false;
      this.bindTelModalVisible = true;
      this.$nextTick(()=>{this.$refs.smsCode.focus();});
      if(!this.time || (this.time===60)){
        this.getSms();
        this.clickSendSms = true;
      }
      this.smsCode = '';
    },
    /**
     * 获取短信验证码
     */
    getSms() {
      let busType = null;
      var phoneNum = null;
      if (!this.mobile){
        if(!this.phone){
          Toast.info(this.TLang('请输入手机号码','address'));
          return;
        }
        busType = 1;
        phoneNum = this.phone;
      }else{
        phoneNum = this.mobile;
      }
      let params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          mobile: phoneNum,
          smsType: 2,
          sourceSys: 1,
          sourceWay: 2,
          businessType: busType,
          unionCode: union,
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      getSmsHandle(params).then((res) => {
        if (res && res.code==200) {
          this.countDown();
          Toast.info(this.TLang('验证码已发送至您的手机','card'));
        }
      });
    },
    /**
     * 校验短信验证码
     */
    valiSms() {
      if (!this.clickSendSms) {
        Toast.info(this.TLang('请先获取验证码','card'));
      }
      if (!this.smsCode || this.smsCode.length < 6) {
        // this.$message.error('请输入正确的验证码');
        return;
      }
      if (!this.mobile){ // 未绑定手机号
        let params = {
          appId: appid,
          msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
          timestamp: +new Date(),
          version: '1.0.1',
          body: JSON.stringify({
            mobile: this.phone,
            smsType: 2,
            sourceSys: 1,
            sourceWay: 2,
            code: this.smsCode,
            updateTime: +new Date(),
          }),
          sign: '',
        };
        params.sign = sha(secretKey + params.body + secretKey);
        updateMobileHandle(params).then((res) => {
          if (res && res.code===200) {
            this.bindTelModalVisible = false;
            // 若用户已设置支付密码
            if (this.hasPayPasswordSet) {
              this.inputPwdModalVisible = true;
            } else {
              this.setPwdModalVisible = true;
              this.paymentPwd = '';
              this.reInputPaymentPwd = '';
            }
          }
        });

      } else{
        let params = {
          appId: appid,
          msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
          timestamp: +new Date(),
          version: '1.0.1',
          body: JSON.stringify({
            mobile: this.mobile,
            smsType: 2,
            sourceSys: 1,
            sourceWay: 2,
            smsCode: this.smsCode,
            unionCode: this.unionFlag,
          }),
          sign: '',
        };
        params.sign = sha(secretKey + params.body + secretKey);
        valiSmsHandle(params).then((res) => {
          if (res && res.code === 200) {
            this.bindTelModalVisible = false;
            this.setPwdModalVisible = true;
            this.paymentPwd = '';
            this.reInputPaymentPwd = '';
          }
        });
      }
    },
    sendSms() {
      this.getSms();
      this.clickSendSms = true;
    },
    /**
     * ？？？？
     */
    setPwdConfirm() {
      this.setPwdModalVisible = false;
    },
    /*
    *有4位以上连续相同的数字或者4位递增或递减
    */
    isSpecial(password){
      debugger;
      let str = password;
      let re = /(\d)\1{3,}/g;
      let isRight = re.test(str);

      str += '';
      let allRe = /\d/g;
      let re1 = /(\(.*\))\1{3,}/g;
      // 判断是否递增
      let increment = str.replace(allRe, function(x1, idx) {
        return `(${x1 - idx})`;
      });
      let isIncrement = re1.test(increment);
      // 判断是否递减
      let decrement= str.replace(allRe, function(x1, idx) {
        return `(${parseInt(x1) + idx})`;
      });
      let isDecrement = re1.test(decrement);
      return isIncrement || isDecrement || isRight;
    },
    /**
     * 设置输入支付密码-确定
     */
    confirmSetPwd() {
      if (!this.paymentPwd) {
        this.setPayPwdTips = this.TLang('请输入四位数字支付密码','card');
        return;
      }
      if(this.isSpecial(this.paymentPwd)){
        this.setPayPwdTips = this.TLang('输入的密码4位数字不能相同或连续','card');
        return;
      }

      if (!this.reInputPaymentPwd) {
        this.setPayPwdTips = this.TLang('请再次输入四位数字支付密码','card');
        return;
      }
      if (this.paymentPwd != this.reInputPaymentPwd) {
        this.setPayPwdTips = this.TLang('checkPayPwd','card');
        return;
      }
      if (this.paymentPwd === this.reInputPaymentPwd) {
        this.setPayPwdTips = '';
      }
      const params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          code: this.smsCode,
          smsType: 2,
          sourceSys: 1,
          sourceSubSys: 0,
          updateTime: formatDateTime(new Date()),
          sourceWay: 2,
          payPassword: this.paymentPwd,
          tokenType: 2,
          unionCode: this.unionFlag,
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      setPaymentPwdHandle(params).then((res) => {
        if (res && res.code === 200) {
          this.setPwdModalVisible = false;
          // this.setPwdSuccessModal = true;
          // 不弹设置密码成功弹窗，直接开启免密
          this.createOrderAction();
        }
      });
    },
    /**
     * 忘记密码
     */
    forgrtPwd() {
      this.inputPwdModalVisible = false;
      this.bindTelModalVisible = true;
      this.$nextTick(()=>{this.$refs.smsCode.focus();});
      if(!this.time || (this.time===60)){
        this.getSms();
        this.clickSendSms = true;
      }
      this.smsCode = '';
    },
    /**
     * 自动获取下一个输入框焦点
     */
    focusNext(val, nextRef,perRef) {
      this.dongjieShow = false;
      this.inputPwdError = '';
      if (val) {
        if(nextRef){
          this.$refs[nextRef].focus();
        }
      }else{
        if(perRef){
          this.$refs[perRef].focus();
        }
      }
    },
    /**
     * 验证支付密码
     */
    validatePayPwd() {
      this.dongjieShow = false;
      this.inputPwdError = '';

      if (!this.pw1 || !this.pw2 || !this.pw3 || !this.pw4) {
        this.inputPwdError = this.TLang('请输入四位数字支付密码','card');
        return;
      }
      let pwd = this.pw1 + this.pw2 + this.pw3 + this.pw4;
      const params = {
        appId: appid,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          password: pwd,
          tokenType: 2,
          validateTime: formatDateTime(new Date()),
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      validatePaymentPwdHandle(params).then((res) => {
        if (res && res.code == 200) {
          this.inputPwdModalVisible = false;
          // 输入密码成功后调用开通免密
          this.createOrderAction();
          this.pw1 = '';
          this.pw2 = '';
          this.pw3 = '';
          this.pw4 = '';
        } else {
          if (res && res.code == 120026){
            // 冻结倒计时
            if(res && res.data && res.data.expireTime){
              this.pwdCountDown(res.data.expireTime);
            }
            this.dongjieShow = true;
          } else{
            this.pw1 = '';
            this.pw2 = '';
            this.pw3 = '';
            this.pw4 = '';
            this.$refs.node1.focus();
            if (res && res.message){
              this.inputPwdError = res.message;
            }
          }
        }
      });
    },
    /*
    *冻结倒计时
    */
    pwdCountDown(timer) {
      if(this.clearTimer){
        clearInterval(this.clearTimer);
      }
      let count = parseInt(timer / 1000);
      this.clearTimer = setInterval(() => {
        if (!count) {
          clearInterval(this.clearTimer);
          this.dongjieShow = false;
        }
        const minute = count > 0 ? parseInt(count / 60) > 9 ? parseInt(count / 60) : '0'+ parseInt(count / 60) : '00';
        const second = count > 0 ? parseInt(count % 60) > 9 ? parseInt(count % 60) : '0'+ parseInt(count % 60) : '00';

        this.countDownTimer = minute + ' : ' + second;
        count--;
      }, 1000);
    },
    /*
    *设置密码成功我知道了点击
    */
    afterSetSuccess(){
      this.setPwdSuccessModal = false;
      this.createOrderAction();
    },
    // 重新计算要重刷页面
    reloadPage() {
      this.deductionFaliedModalVisible = false;
      window.location.reload();
    },
    /**
     * 倒计时
     */
    countDown() {
      debugger;
      _interval = setInterval(() => {
        if (this.time > 0) {
          this.time = this.time - 1;
        } else {
          clearInterval(_interval);
          this.time = 60;
        }
      }, 1000);
    },
    /*
    *关闭
    */
    closeClick(done,type){
      console.log('type',type);
      // 需要判断是不是要退出设置密码
      this.quitModalVisible = true;
      // 绑定手机号
      this.currentStep = type;
      this.bindTelModalVisible = false;
      this.setPwdModalVisible = false;
      // this.phone = '';
    },
    /*
    *二次确认退出密码设置
    */
    quitPwdSet(){
      this.quitModalVisible = false;
      this.bindTelModalVisible = false;
      this.setPwdModalVisible = false;
      this.paymentPwd = '';
      this.reInputPaymentPwd = '';
      this.phone = '';
      this.setPayPwdTips = '';
      this.getUserInfo();
    },
    /*
    *继续设置
    */
    goOnSet(){
      this.quitModalVisible = false;
      if(this.currentStep==='bindPhone'){ // 绑定手机号
        this.bindTelModalVisible = true;
        this.clickSendSms = false;
        this.smsCode = '';
      }else if(this.currentStep === 'setPwd'){ // 设置密码
        this.setPwdModalVisible = true;
        this.paymentPwd = '';
        this.reInputPaymentPwd = '';
      }
    },
    /*
    *正式开通免密
    */
    createOrderAction() {
      const params = {
        appId: appid,
        union: union,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          setType: 'add',
          tagType: [30],
          createTime: formatDateTime(new Date()),
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      openFreePay(params).then((res) => {
        if (res) {
          this.value = true;
          Toast.info(this.TLang('您已成功开启免密抵扣','user'), 2);
          this.getUserInfo();
        }
      });
    },
    /*
    *关闭免密
    */
    openCloseFreeModal() {
      const params = {
        appId: appid,
        union: union,
        msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
        timestamp: +new Date(),
        version: '1.0.1',
        body: JSON.stringify({
          setType: 'remove',
          tagType: [30],
          createTime: formatDateTime(new Date()),
        }),
        sign: '',
      };
      params.sign = sha(secretKey + params.body + secretKey);
      openFreePay(params).then((res) => {
        if (res) {
          this.closeFreeSetVisible = false;
          this.value = false;
          Toast.info(this.TLang('您已关闭免密抵扣','user'), 2);
          this.getUserInfo();
        }
      });
    },
  },
  filters: {
    // 脱敏,隐藏手机号的中间四位
    mobileFormat(val) {
      if (val) {
        let tel = val + '';
        tel = tel.substr(0, 3) + '****' + tel.substr(7);
        return tel;
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="less">
@import "./index.less";
</style>
<style lang="less" scoped>
.mainWrap {
  width: 992px;
  padding: 20px;
  min-height: 442px;
  box-sizing: border-box;
  border: 1px solid #ededed;
  /deep/ .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
  /deep/ .el-tabs__header {
    margin-bottom: 40px;
    .el-tabs__item {
      font-size: 20px;
      line-height: 26px;
    }
    .is-active {
      font-weight: bold;
      color: #333;;
    }
    .el-tabs__active-bar {
      background-color: #3D96E2;
      height: 4px;
      border-radius: 2px;
    }
  }
  .tabs {
    width: 100%;
    .tabList {
      display: inline-block;
      width: 82px;
      text-align: center;
      margin-right: 40px;
      font-size: 20px;
    
      color: #999;
      line-height: 26px;
      padding-bottom: 6px;
      margin-bottom: 40px;
      cursor: pointer;
    }
    .active {
      font-size: 20px;
    
      font-weight: bold;
      color: #333333;
      border-bottom: 4px solid #3D96E2;
    }
  }
}
.secretFreeSet {
  line-height: 28px;
  color: #666;
  width: 100%;
  .label {
    width: 110px;
    line-height: 28px;
    font-size: 14px;
    text-align: left;
  }
  .switch {
    margin-right: 12px;
    /deep/ .el-switch__core {
      height: 28px;
      border-radius: 14px;
      &::after {
        width: 24px;
        height: 24px;
      }
    }
    /deep/ .el-switch.is-checked {
      .el-switch__core {
        &::after {
          margin-left: -25px;
        }
      }
    }
  }
  .tips {
    width: 500px;
    padding-left: 18px;
    background: url("~@assets/images/freeSecret_tip.png") left center no-repeat;
    background-size: 14px auto;
    font-size: 12px;
    color: #B2B2B2;
    line-height: 28px;
  }
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.clearfix {
  *zoom: 1;
}
.fr {
  float: right;
}
.fl {
  float: left;
}
</style>
